import React from 'react';
import { Link } from 'react-router-dom';

import classes from './ModuleOverviewSection.module.css';
import RouteEndPoints from '../../../utilities/RouteEndPoints';
import ProgressBar from '../../UI/ProgressBar/ProgressBar';
import Button from '../../UI/Button/Button';
import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import Constants from '../../../utilities/Constants';
import ShowLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
// import ModuleReportCard from '../../Cards/ModuleReportCard/ModuleReportCard';

const ModuleOverviewSection = (props) => {

    let classGrades = 0, rating = 0, activeStudents = 0, totalStudents = 0, activeStudentPercentage = 0;
    if (!IsObjectEmpty(props.ongoingModuleData) && !IsObjectEmpty(props.ongoingModuleData.moduleMetaData)) {
        classGrades = !IsStringEmpty(props.ongoingModuleData.moduleMetaData.classGrade) ? props.ongoingModuleData.moduleMetaData.classGrade : 0;

        rating = !IsStringEmpty(props.ongoingModuleData.moduleMetaData.rating) ? props.ongoingModuleData.moduleMetaData.rating : 0;

        activeStudents = !IsStringEmpty(props.ongoingModuleData.moduleMetaData.activeStudents) ? props.ongoingModuleData.moduleMetaData.activeStudents : 0;

        totalStudents = !IsStringEmpty(props.ongoingModuleData.moduleMetaData.totalStudents) ? props.ongoingModuleData.moduleMetaData.totalStudents : 0;

        if (activeStudents > 0) {
            activeStudentPercentage = Math.floor(activeStudents / totalStudents * 100);
        }
    }
    // console.log('moduleOverviewSection Plan => ', props);

    const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

    const startedBy = GetFromLocalStorage("username");

    let plan = {};
    if (isLearner && !IsObjectEmpty(props.data)) {
        plan = props.data.todaysPlan;
    } else if (!IsObjectEmpty(props.data)) {
        plan = props.data.upcomingSessionPlan;
    }

    const topicNames = !IsObjectEmpty(plan) && !IsListEmpty(plan.topicsList)
        ? plan.topicsList.map((topicItem, index) => {
            return (
                <Link key={index} className={classes.RemoveTextDecoration}
                    to={{
                        pathname: isLearner === false
                            ? RouteEndPoints.CURRICULUM_PAGE + '/' + props.batchCode + '/' + props.data.module.name + '/topic/' + topicItem.topicId
                            : RouteEndPoints.PROGRAM_MODULES_PAGE + '/' + props.batchCode + '/' + props.data.module.name + '/' + topicItem.topicId,
                        state: { type: 'topic' }
                    }

                    }>
                    <h5 className={classes.TopicHeading}>{topicItem.topicName}</h5>
                </Link>
            );
        }) : <p>No upcoming session plan found.</p>;

    const liveSessionsLearner = !IsObjectEmpty(props.data) && !IsObjectEmpty(props.data.todaysPlan) && !IsListEmpty(props.data.todaysPlan.liveSession)
        ? props.data.todaysPlan.liveSession.map((liveSession, index) => {
            console.log('Live SEssions => ', liveSession)
            return (
                <div key={index}>
                    {
                        !IsStringEmpty(liveSession.pending) && liveSession.pending
                            ? <>
                                <Button
                                    label='JOIN LIVE SESSION'
                                    fontSize="0.75em"
                                    clicked={!liveSession.started ? null : () => props.showLiveSessionPopup(liveSession.liveSessionId)}
                                    disabled={!liveSession.started}
                                    styleclass=""
                                    margin="1em 0px 0px 0px"
                                    padding="8px 24px"
                                />
                                <br />
                                {!liveSession.started
                                    ? <span className={classes.BeginsText}>
                                        BEGINS at&nbsp;
                                        {
                                            !IsStringEmpty(liveSession.openTime)
                                                ? liveSession.openTime.split(',')[1].trim() : ''
                                        }
                                    </span>
                                    : <span className={classes.BeginsText}>
                                        Live Session is Started </span>
                                }
                            </>
                            : null}
                </div>
            );
        }) : null;

    const liveSessionsInstructor = !IsObjectEmpty(props.data) && !IsListEmpty(props.data.upcomingSessionPlan)
        ? props.data.upcomingSessionPlan.map((liveSession, index) => {
            return (
                <div key={index}>
                    <Link className={classes.RemoveTextDecoration}
                        to={RouteEndPoints.CURRICULUM_PAGE + '/' + props.batchCode + '/' + props.data.module.name + '/topic/' + liveSession.topicId}>
                        <h5 className={classes.TopicHeading}>{liveSession.name}</h5>
                    </Link>
                    {
                        liveSession.showLoader
                            ? <div className={classes.MiniLoaderContainer}>
                                <ShowLoader isLoading={true} transparentBg={true} />
                            </div>
                            : !liveSession.sessionEnded
                                ? <Button
                                    label={!IsStringEmpty(liveSession.startURL) ? 'JOIN LIVE SESSION' : 'START LIVE SESSION'}
                                    fontSize="0.75em"
                                    width="174px"
                                    styleclass=""
                                    margin="0.5em 0px 0px 0px"
                                    padding="8px 24px"
                                    disabled={!liveSession.enableButton}
                                    clicked={liveSession.enableButton && !liveSession.showLoader
                                        ? () => props.startLiveSession(liveSession.liveSessionId, liveSession.startURL, index, startedBy)
                                        : null}
                                /> : <p className={classes.SessionEndedText}>Live Session Ended </p>
                    }
                    {liveSession.sessionEnded
                        ? null
                        : !liveSession.enableButton
                            ? <span className={classes.BeginsText}>
                                BEGINS at&nbsp;{liveSession.scheduleTime}
                            </span>
                            : null
                    }
                </div>
            )
        }) : null;

    return (
        <>
            {
                props.forPerformanceTab === true ? null
                    : <h3 className={classes.CardHeading}>Module Overview</h3>
            }
            <div className={classes.ModuleOverviewSectionContainer}>
                <div className={[classes.ModuleOverviewCard, props.forPerformanceTab === true ? classes.FullWidth : ''].join(' ')}>
                    <div className={classes.ModuleDetails}>
                        {
                            props.forPerformanceTab === true ? null
                                : <Link className={classes.TextLink}
                                    to={isLearner === false
                                        ? RouteEndPoints.CURRICULUM_PAGE + '/' + props.batchCode + '/' + props.data.module.name
                                        : RouteEndPoints.PROGRAM_MODULES_PAGE + '/' + props.batchCode + '/' + props.data.module.name}>
                                    VIEW CURRICULUM
                                </Link>
                        }
                        <div className={classes.ModuleMetaData}>
                            <img className={classes.ModuleLogo} src={props.data.module.logo} alt="module overview module logo" />
                            <div>
                                <h4 className={classes.ModuleName}>{props.data.module.name}</h4>
                                {
                                    props.forPerformanceTab === true
                                        ? <div className={classes.ProfilePicContainer}>
                                            <img className={classes.InstructorProfilePic} src={props.data.module.logo} alt="module overview module logo" />
                                            <p className={classes.InstructorName}>Qaifi Khan</p>
                                        </div> : null
                                }
                            </div>
                        </div>
                        <div className={classes.ModuleProgress}>
                            <div className={classes.ProgressItem}>
                                <span>{props.forPerformanceTab === true ? 'Progress' : 'Hours Taught'}</span>
                                <div className={classes.ProgressDiv}>
                                    <ProgressBar styleclass="Rounded" showProgressText={true}
                                        progress={props.data.module.hoursTaught.value}
                                        progressValue={props.data.module.hoursTaught.label} />
                                </div>
                            </div>
                            <div className={classes.ProgressItem}>
                                <span>Live Sessions</span>
                                <div className={classes.ProgressDiv}>
                                    <ProgressBar styleclass="Rounded" showProgressText={true}
                                        progress={props.data.module.liveSessionProgress.value}
                                        progressValue={props.data.module.liveSessionProgress.label} />
                                </div>
                            </div>
                            <div className={classes.ProgressItem}>
                                <span>Assignments</span>
                                <div className={classes.ProgressDiv}>
                                    <ProgressBar styleclass="Rounded" showProgressText={true}
                                        progress={props.data.module.assignmentProgress.value}
                                        progressValue={props.data.module.assignmentProgress.label} />
                                </div>
                            </div>
                            <div className={classes.ProgressItem}>
                                <span>MCQ Quiz</span>
                                <div className={classes.ProgressDiv}>
                                    <ProgressBar styleclass="Rounded" showProgressText={true}
                                        progress={props.data.module.quizProgress.value}
                                        progressValue={props.data.module.quizProgress.label} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.TodaysPlan}>
                        <h4 className={classes.PlanHeading}>
                            {
                                props.forPerformanceTab === true ? "Today's Plan" : "Upcoming Session Plan"
                            }
                        </h4>
                        {
                            !IsObjectEmpty(props.data.upcomingSessionPlan)
                                ? <>
                                    <span className={classes.PlanDate}>{props.data.upcomingSessionPlan.date}</span>

                                    {
                                        isLearner
                                            ? <>
                                                {topicNames}
                                                {
                                                    !IsStringEmpty(props.data.upcomingSessionPlan.quiz.pending) && props.data.upcomingSessionPlan.quiz.pending
                                                        ? <p className={classes.PlanEntity}>
                                                            Quiz <span>opens at {props.data.upcomingSessionPlan.quiz.openTime}</span>
                                                        </p>
                                                        : null
                                                }
                                                {
                                                    !IsStringEmpty(props.data.upcomingSessionPlan.assignment.pending) && props.data.upcomingSessionPlan.assignment.pending
                                                        ? <p className={classes.PlanEntity}>
                                                            Assignment <span>opens at {props.data.upcomingSessionPlan.assignment.openTime}</span>
                                                        </p>
                                                        : null
                                                }
                                                {liveSessionsLearner}
                                            </>
                                            : <>
                                                {liveSessionsInstructor}
                                            </>
                                    }
                                </>
                                : <p>No upcoming session plan available.</p>
                        }
                    </div>
                </div>
                <div className={classes.ModuleReportCard}>
                    <h3>Module Report</h3>
                    <div className={classes.ProgressCard}>
                        <p className={classes.ProgressStat}>{(rating !== 0
                            ? rating / 20
                            : 0)} / 5</p>
                        <p className={classes.ProgressText}>My Rating</p>
                        <div className={classes.Stars}
                            style={{
                                "--rating": (rating !== 0
                                    ? rating / 20
                                    : 0)
                            }}>
                        </div>
                    </div>
                    <div className={classes.ProgressCard}>
                        <p className={classes.ProgressStat}>{classGrades}<span>%</span></p>
                        <p className={classes.ProgressText}>Class Grade</p>
                        <div className={classes.ProgressBarDiv}>
                            <ProgressBar
                                styleclass={classGrades >= 80 ? "Green"
                                    : classGrades >= 70 ? "Yellow" : "Red"}
                                showProgressText={false} progress={classGrades} />
                        </div>
                    </div>
                    <div className={classes.ProgressCard}>
                        <p className={classes.ProgressStat}>{activeStudents}<span> / {totalStudents}</span></p>
                        <p className={classes.ProgressText}>Active Students</p>
                        <div className={classes.ProgressBarDiv}>
                            <ProgressBar styleclass={activeStudentPercentage >= 80 ? "Green"
                                : activeStudentPercentage >= 70 ? "Yellow" : "Red"}
                                showProgressText={false} progress={activeStudentPercentage} />
                        </div>
                    </div>
                    {/* <Link className={classes.ProgressTextLink} to={RouteEndPoints.PROGRAM_SUBMISSIONS_PAGE + '/' + props.batchCode}>
                        VIEW DETAILED REPORT
                    </Link> */}
                    <Link className={classes.ProgressTextLink} to={RouteEndPoints.REPORTS_PAGE + '/overall-report'} >
                        VIEW DETAILED REPORT
                    </Link>
                </div>
            </div>
        </>
    );
}

export default ModuleOverviewSection;